// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { discontinuedMessageStyle } from "@guestsupply/App/Components/Product/ProductDiscontinuedMessage";
import QuestionTooltip from "@guestsupply/XDL/Icons/QuestionTooltip";
import { css } from "styled-components";

discontinuedMessageStyle.messageWrapper = {
    css: css`
        display: flex;
        column-gap: 8px;
        margin: 8px 0;
    `,
};

discontinuedMessageStyle.message = {
    size: 12,
    weight: "bold",
    css: css`
        line-height: 12px;
    `,
};

discontinuedMessageStyle.icon = {
    src: QuestionTooltip,
    size: 12,
    color: "text.link",
};
